import angular from 'angular'

import { auditRoutes } from './audit.routes'

import { auditService } from './services/audit.service'

import { auditDetailCard } from './directives/audit-detail-card/audit-detail-card.directive'
import { auditFormField } from './directives/audit-form-field/audit-form-field.directive'
import { auditListItem } from './directives/audit-list-item/audit-list-item.directive'
import { auditStatusBadge } from './directives/audit-status-badge/audit-status-badge.directive'
import { auditScoreBadge } from './directives/audit-score-badge/audit-score-badge.directive'
import { auditEmptyMode } from './directives/audit-empty-mode/audit-empty-mode.directive'
import { auditSkeletonLoading } from './directives/audit-skeleton-loading/audit-skeleton-loading.directive'
import { auditSocialMediaPost } from './directives/audit-social-media-post/audit-social-media-post.directive'
import { auditSocialMediaFilters } from './directives/audit-social-media-filters/audit-social-media-filters.directive'
import { auditSocialMediaAccounts } from './directives/audit-social-media-accounts/audit-social-media-accounts.directive'
import { auditSocialMediaPosts } from './directives/audit-social-media-posts/audit-social-media-posts.directive'
import { auditSocialMediaCarousel } from './directives/audit-social-media-carousel/audit-social-media-carousel.directive'

import { socialMediaNonConformityDialog } from './dialogs/social-media/non-conformity/non-conformity.directive'

const module = angular
  .module('deskfy.audit', [])
  .config(auditRoutes)
  .factory('AuditService', auditService)
  .directive('auditDetailCard', auditDetailCard)
  .directive('auditFormField', auditFormField)
  .directive('auditListItem', auditListItem)
  .directive('auditStatusBadge', auditStatusBadge)
  .directive('auditScoreBadge', auditScoreBadge)
  .directive('auditEmptyMode', auditEmptyMode)
  .directive('auditSkeletonLoading', auditSkeletonLoading)
  .directive('auditSocialMediaPost', auditSocialMediaPost)
  .directive('auditSocialMediaFilters', auditSocialMediaFilters)
  .directive('auditSocialMediaAccounts', auditSocialMediaAccounts)
  .directive('auditSocialMediaPosts', auditSocialMediaPosts)
  .directive('auditSocialMediaCarousel', auditSocialMediaCarousel)
  .directive('socialMediaNonConformityDialog', socialMediaNonConformityDialog)

export const auditModule = module
